import { useState } from "react"
import { Link } from "@react-navigation/native"
import {Modal, View, Text, StyleSheet, Pressable, Linking} from "react-native"
import AntDesign from 'react-native-vector-icons/AntDesign'

export function HelpModal({visible, setVisible}) {
    const [closeHovered, setCloseHovered] = useState(false)

    return (
        <Modal transparent visible={visible}>
            <View style={styles.outerView}>
                <View style={styles.innerView}>
                    <View style={{justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center'}}>
                        <Text style={styles.headerText}>What is this?</Text>
                        <Pressable
                            onPress={() => setVisible(false)}
                            onHoverIn={() => setCloseHovered(true)}
                            onHoverOut={() => setCloseHovered(false)}
                            hitSlop={12}
                            accessibilityRole="button"
                            accessibilityLabel="Close"
                        >
                            <View style={[{padding: 6, borderRadius: 8}, closeHovered && {backgroundColor: '#f1f3f5'}]}>
                                <AntDesign name="close" size={22} color={"#6b7280"} />
                            </View>
                        </Pressable>
                    </View>
                    <Text style={{fontFamily: "PoppinsRegular", marginTop: 16, fontSize: 14, lineHeight: 21, color: '#1f2430'}}>
                        billing.bh is an invoice payment service allowing clients to quickly and easily pay their legal fees online.
                    </Text>
                    <Text style={{fontFamily: "PoppinsRegular", marginTop: 12, fontSize: 14, lineHeight: 21, color: '#1f2430'}}>
                        billing.bh is owned by Consult Me. You can visit our website and our range of legal consultants at <Text onPress={() => Linking.openURL("https://www.consultmebh.com")} style={{color: 'rgb(0, 54, 246)'}}>https://consultmebh.com</Text>
                    </Text>
                </View>
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    outerView: {
        flex: 1,
        backgroundColor: 'rgba(15, 23, 42, 0.45)',
        alignItems: 'center',
        justifyContent: 'center'
    },
    innerView: {
        backgroundColor: 'white',
        padding: 28,
        marginHorizontal: 16,
        borderWidth: 1,
        borderColor: '#e6e8ec',
        borderRadius: 18,
        maxWidth: 500,
        shadowColor: '#101828',
        shadowOffset: { width: 0, height: 8 },
        shadowOpacity: 0.18,
        shadowRadius: 24,
        elevation: 8
    },
    headerText: {
        fontFamily: "PoppinsSemiBold",
        fontSize: 20,
        color: '#1f2430'
    }
})